
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/curators",
      function () {
        return require("private-next-pages/curators.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/curators"])
      });
    }
  